<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import OrthoPCCompanyAddEditForm from "@/components/models/company/forms/OrthoPCCompanyAddEditForm.vue";
import { useAbility } from "@casl/vue";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.orthoPcCompany" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PRACTICE__COMPANY);
    },
  },
});
</script>

<template>
  <v-skeleton-loader>
    <ortho-p-c-company-add-edit-form />
  </v-skeleton-loader>
</template>

<style scoped></style>
